import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { UserProfileDialogService } from '@interacta-shared/feature-caronte';
import { IUser } from '@interacta-shared/util-caronte';
import { profile } from '@modules/app-routing/routes';
import { UserActivitiesService } from '@modules/profile/services/user-activities.service';
import { UserCapabilitiesService } from './user-capabilites.service';

@Injectable()
export class CoreUserProfileDialogService extends UserProfileDialogService {
    private readonly userActivitiesService = inject(UserActivitiesService);
    private readonly userCapabilitiesService = inject(UserCapabilitiesService);

    constructor() {
        super();

        this.userCapabilitiesService.userCapabilities$
            .pipe(takeUntilDestroyed())
            .subscribe((capabilities) =>
                this.rootPermission.set(!!capabilities?.resellerAdmin),
            );
    }

    toggleFollow(): void {
        const user = this.data().user;
        if (!user) {
            throw Error("can't toggleFollow on undefined user");
        }
        this.userActivitiesService.toggleUserFollow(user).subscribe({
            next: () => {
                const newUser = {
                    ...user,
                    followedByMe: !user.followedByMe,
                };
                this.update({ user: newUser, isFetching: false });
                this.toggleUserFollow$ = newUser;
            },
            error: (error) => {
                throw error;
            },
        });
    }

    navigate(userId?: IUser['id']): RouterLink['routerLink'] {
        if (!userId) return null;
        return ['/', profile, userId];
    }
}
